import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  apiKey: string | null;
  apiUrl: string;
  siteId: string | null;
  siteName: string | null;
  setCredentials: (apiKey: string, apiUrl: string) => void;
  setSiteInfo: (siteId: string, siteName: string) => void;
  logout: () => void;
  isAuthenticated: boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      apiKey: null,
      apiUrl: 'https://answer-nodes-api.workers.dev',
      siteId: null,
      siteName: null,
      isAuthenticated: false,
      setCredentials: (apiKey, apiUrl) => set({ apiKey, apiUrl, isAuthenticated: true }),
      setSiteInfo: (siteId, siteName) => set({ siteId, siteName }),
      logout: () => set({ apiKey: null, siteId: null, siteName: null, isAuthenticated: false })
    }),
    {
      name: 'answer-nodes-auth'
    }
  )
);

interface UIState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState>()((set) => ({
  sidebarOpen: true,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen }))
}));
